import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { merge, of, timer } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { map, switchMap, takeWhile, tap } from 'rxjs/operators';
import { Times } from '../../enums';
import { RequestLoaderService } from './request-loader.service';

@Component({
  selector: 'portal-request-loader',
  templateUrl: './request-loader.component.html',
  styleUrls: ['./request-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RequestLoaderComponent implements OnInit {
  private readonly preloaderService = inject(RequestLoaderService);
  private readonly cdr = inject(ChangeDetectorRef);

  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  progress$: Observable<number>;
  isScreenLocked$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private readonly maxProgress = 100;

  ngOnInit(): void {
    this.progress$ = this.preloaderService.loaderState.asObservable().pipe(
      switchMap(({ isLoading, lockScreen }) => {
        if (!isLoading) {
          return this.complete$();
        }

        this.isLoading$.next(true);
        this.isScreenLocked$.next(lockScreen);

        const endProgress = 70;
        this.cdr.detectChanges();

        return timer(0, this.maxProgress).pipe(
          map(value => (value + 1) * Times.Ten),
          takeWhile(percents => percents <= endProgress),
        );
      }),
    );
  }

  complete$(): Observable<number> {
    const progressEnd$ = of(this.maxProgress).pipe(
      tap(() => {
        this.isScreenLocked$.next(false);
        this.isLoading$.next(false);
      }),
    );

    return merge(progressEnd$);
  }
}
